import { Link } from "react-router-dom";
import PlayerItem from "../components/PlayerItem";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { PitchContext } from "../context/PitchContex";

function AllPlayers() {
  const [allPlayers, setAllPlayers] = useState();
  const {
    user,
    backendURL,
    token,
    setPending,
    setAlertMessage,
    setIsErr,
    setShowAlert,
  } = useContext(PitchContext);
  const [search, setSearch] = useState("");
  const [positionFilter, setPositionFilter] = useState("");
  const [ageRangeFilter, setAgeRangeFilter] = useState("");
  const [filteredPlayers, setFilteredPlayers] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const getAllPlayers = () => {
    setPending(true);
    axios
      .get(backendURL + "player/get")
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setAllPlayers(response.data.players);
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setAlertMessage(err.response.data.message);
        setIsErr(true);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    document.title = "Oyuncu Bul | Adam Eksik | Halısaha";
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getAllPlayers();
  }, []);

  useEffect(() => {
    let filtered = allPlayers || [];
    if (search) {
      filtered = filtered.filter(
        (item) =>
          item.city.toLowerCase().includes(search.toLowerCase()) ||
          item.fullname.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (positionFilter) {
      filtered = filtered.filter((item) => item.position === positionFilter);
    }
    if (ageRangeFilter) {
      const [minAge, maxAge] = ageRangeFilter.split("-").map(Number);
      filtered = filtered.filter(
        (item) => item.age >= minAge && item.age <= maxAge
      );
    }
    setFilteredPlayers(filtered);
    // setCurrentPage(1);
  }, [search, positionFilter, ageRangeFilter, allPlayers]);

  return (
    <div className="my-10 px-4 relative">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Takım Arkadaşı Bul</h1>
        {user && user.playerProfile.isCreated ? (
          <img
            className="w-9 h-9 rounded-full object-cover ring-2 ring-[#4d9041]/20 hover:ring-[#4d9041] transition-all duration-300"
            src={user.profilePicture}
            alt="Profil"
          />
        ) : (
          <Link to={user ? "/oyuncu-ekle" : "/giris-yap"}>
            <button className="p-3 bg-[#4d9041] text-white rounded-lg hover:bg-[#62a556] transition-colors cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </button>
          </Link>
        )}
      </div>

      <div className="mb-4 flex flex-col gap-4">
        {/* Position and Age Range Selects - Side by side on small screens */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <select
            value={positionFilter}
            onChange={(e) => setPositionFilter(e.target.value)}
            className="w-full sm:w-1/2 px-4 py-3 border rounded-lg shadow-sm"
          >
            <option value="">Pozisyon Seç</option>
            <option value="Kaleci">Kaleci</option>
            <option value="Defans">Defans</option>
            <option value="Ortasaha">Orta Saha</option>
            <option value="Forvet">Forvet</option>
          </select>
          <select
            value={ageRangeFilter}
            onChange={(e) => setAgeRangeFilter(e.target.value)}
            className="w-full sm:w-1/2 px-4 py-3 border rounded-lg shadow-sm"
          >
            <option value="">Yaş Aralığı Seç</option>
            <option value="18-25">18-25</option>
            <option value="26-35">26-35</option>
            <option value="36-45">36-45</option>
            <option value="46-60">46-60</option>
          </select>
        </div>

        {/* Search Input - Below selects */}
        <input
          type="text"
          placeholder="Şehir veya isim ile oyuncu ara..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-[#4d9041]"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredPlayers
          ?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
          .map((item, index) => (
            <div key={index}>
              <Link to={`/oyuncu/${item._id}`}>
                <PlayerItem player={item} />
              </Link>
            </div>
          ))}
      </div>
      <div className="flex justify-center mt-6 space-x-2">
        {/* Previous Button */}
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          className="px-4 py-2 bg-gray-300 rounded-md disabled:opacity-50 cursor-pointer"
        >
          Previous
        </button>

        {/* Page Numbers */}
        {Array.from(
          { length: Math.ceil((filteredPlayers?.length || 0) / itemsPerPage) },
          (_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index + 1)}
              className={`px-4 py-2 rounded-md ${
                currentPage === index + 1
                  ? "bg-[#4d9041] text-white"
                  : "bg-gray-200 text-gray-800"
              } transition-colors`}
            >
              {index + 1}
            </button>
          )
        )}

        {/* Next Button */}
        <button
          disabled={
            currentPage * itemsPerPage >= (filteredPlayers?.length || 0)
          }
          onClick={() => setCurrentPage((prev) => prev + 1)}
          className="px-4 py-2 bg-gray-300 rounded-md disabled:opacity-50 cursor-pointer"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default AllPlayers;
